export {
  default,
  DEFAULT_MAX_FILE_SIZE,
  DEFAULT_MAX_FILE_SIZE_TEST,
} from 'ember-simplepractice/services/file-upload';
export const DEFAULT_DOCUMENTS_MAX_FILE_SIZE = 52428800; // ~50MB
